export default __webpack_public_path__ + "static/media/CloseFilter.c4210503.svg";